import React from 'react';
import { usePlace } from '../../nucleus/place';
import LogView from './LogView';
import InboxView from './InboxView';
import './ActivitySection.css';

// ACTIVITY — what happened, across all of it: the Log (one ledger of every
// read, write and decision) and the Inbox (what arrived for you). Proposals,
// whatever became of them, are the Graph's Review page (its All lane).
export default function ActivitySection() {
    const { section, page } = usePlace();
    if (!section) return null; // on the way out to another address
    if (page?.id === 'inbox') return <InboxView />;
    return <LogView />;
}
